"use client";
import { Box } from "@ecco/ui/box";
import type { BaseMoney } from "@graphql/generated/types";
import { useEffect } from "react";
import { activeSiteConfig } from "@config/site/site-config";
import { useMoney } from "@ecco/ui/use-money";

interface GrabPayWidgetProps {
    productPrice: BaseMoney;
    locale: string;
    productId: string;
}

declare global {
    interface Window {
        GrabWidget?: {
            invoke: () => void;
        };
    }
}

// Global flag to track if invoke has been called
let hasInvoked = false;

const GrabPayWidget = ({ productPrice, locale, productId }: GrabPayWidgetProps) => {
    const price = useMoney({ money: productPrice, locale });

    const moneyFormat =
        activeSiteConfig.country === "SG"
            ? `${price.currencySymbol}{{amount}}`
            : `${price.currencySymbol} {{amount}}`;

    useEffect(() => {
        // Reset the flag when product changes
        hasInvoked = false;

        // Call invoke only once after component mounts
        queueMicrotask(() => {
            if (window?.GrabWidget && activeSiteConfig?.hasGrabPayWidget && !hasInvoked) {
                hasInvoked = true;
                window.GrabWidget.invoke();
            }
        });
    }, [productId]);

    return (
        <Box
            key={productId} // Force remount when product changes
            className="grab-price-divider-widget"
            data-widget-type="single_line"
            data-currency-code={productPrice?.currencyCode}
            data-money-format={moneyFormat}
            data-product-price={price.amount.replace(/,/g, "")}
            data-widget-size="small"
            data-min-price="50"
            data-widget-alignment="left"
        />
    );
};

export default GrabPayWidget;
